export const teamInfo = [
  {
    name: "Nicole English",
    ocupation: "Chief Operating Officer",
    description:
      "Bringing the thunder from Downunder, Nicole is Troy’s right-hand man and oversees the day to day running of the entire operation. She brings to the project years of experience in team building, marketing, and management. She has a meticulous eye for detail and a work ethic so strong that she bleeds BerserkerMail.",
    photo: "./team-pictures/nicole.png",
  },
  {
    name: "Pedro Palhari",
    ocupation: "Tech Lead",
    description:
      "Pedro is an exceptionally talented developer, graduating in the top 1% of his class. He eats, sleeps, and breathes success, and has a maturity that extends beyond coding and into areas of optimization, architecture, and problem solving.  Pedro brings a vast level of experience to the project, having been involved in his own start-up venture and publishing academic papers in cancer drug research. His passion and dedication for this project has been a guiding influence throughout the development team.",
    photo: "./team-pictures/palhari.jpeg",
  },
  {
    name: "Rogério Junior",
    ocupation: "Tech Lead",
    description:
      "Drawing from his many creative talents, Rogério brings to the project a combination of technical skill and artistic flair, with the courage and determination of an artist that borders on transgression and rebellion, impossible to be defeated. These attributes have been paramount in the success of the project and a driving force in maintaining the expectations and work ethic of his fellow team members. Rogério’s multi-faceted skill set make him the go-to guy for all things Berserker. ",
    photo: "./team-pictures/rogerio.png",
  },
  {
    name: "Guilherme Marques",
    ocupation: "Fullstack Developer",
    description:
      "Guilherme is an exceptionally skilled, and experienced developer in languages spanning from pure low-level C/C++ programming to high level Typescript. He brings a rich blend of realism, philosophy, and life experience to the development environment, and is a highly respected team member.",
    photo: "./team-pictures/gui.jpeg",
  },
  {
    name: "Gabriel Faria",
    ocupation: "Fullstack Developer",
    description:
      "Gabriel is the ultimate professional, always willing to learn and pass his knowledge onto his team members. As an experienced developer, he also has a flair for teaching, who is always willing to go the extra mile for the project and team members. He is regarded very highly as a full stack specialist, and is known for his dedication and laser focus on the pursuit of excellence.",
    photo: "./team-pictures/gabriel.jpeg",
  },
  {
    name: "Lucas Santana",
    ocupation: "Fullstack Developer",
    description:
      "Unassuming and funny, Lucas is a key contributor to the development of BerserkerMail. He brings unity to the team by being a focused, quick thinking, problem solver, and developing unique and elegant codes synonymous with a top-level programmer.",
    photo: "./team-pictures/lucas.jpg",
  },
  {
    name: "Gabriel Amorim",
    ocupation: "Front-end Developer",
    description:
      "Amorim’s grounding presence plays an integral role in the team’s morale. He unites the team, by staying ahead of issues and maintaining close attention to the current state of production. Amorim is an excellent student of his craft, and just as good as paying it forward to his team members. Amorim is the glue that holds the team together when the pressure is on, and the deadlines are looming.",
    photo: "./team-pictures/amorim.jpeg",
  },
  {
    name: "Mateus Paula",
    ocupation: "Front-end Developer",
    description:
      "Mateus wakes up each day with his focus squarely on how to excel at his craft. Armed with his passion for web development and dedication towards excellence, he’s always looking to improve the quality of his code and advance his education to achieve his goals. Mateus is a valued member of the team who goes out of his way to assist in the project’s growth and success whenever asked.  As our ‘King of CSS', he is responsible for BerserkerMail’s beautiful screens.",
    photo: "./team-pictures/mateus.png",
  },
  {
    name: "Sheila dela Cruz",
    ocupation: "Senior Designer",
    description:
      "With 9+ years of experience in digital design, Sheila has worked across a huge variety of projects creating visually engaging and high-quality designs, from websites and apps to internal marketing collaterals. Her ability to solve problems on the fly, combined with her attention to detail and creative talent, make her a highly respected and crucial member of the BerserkerMail team.",
    photo: "./team-pictures/sheila.jpg",
  },
  {
    name: "Hitesh Grover",
    ocupation: "Senior Software Engineer - iOS",
    description:
      "Passionate about programming, Hitesh started his career as a mobile app developer 6 years ago. Since then he has worked with people across three continents and nine countries. He came to us with a diverse background in developing apps for travel, social media, jewelry and workforce management industries with some apps being used by over a million people daily. When he’s not working, you could find him spending time with friends and family, with his head stuck in a book, or even writing his own stories. With a sharp eye for detail and an endless pursuit of excellence, Hitesh is on a quest to develop world class platforms and strives to showcase his talent daily.",
    photo: "./team-pictures/hitesh.jpg",
  },
  {
    name: "Sara Marques",
    ocupation: "Tech Support & Quality Assurance",
    description:
      "As our newest member of the BerserkerMail tech support team, Sara has quickly become a great asset to the entire company. Her willingness to learn new skills, and deep dive into all things Berserker, has seen her expand her tech support role into quality assurance. Being a psychology student and English language teacher in her ‘other’ life gives her additional superpowers in the areas of the user experience and customer relations.",
    photo: "./team-pictures/sara.png",
  },
];
